import { render, staticRenderFns } from "./PropertySelectMultipleColoredTag.vue?vue&type=template&id=0a80f496"
import script from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js"
export * from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports